import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectWinloses = (state : GlobalState) => state.managers.winloses;

export const managersWinlosesSelector = createSelector(
    [selectWinloses],
    data => data
)
